import { render, staticRenderFns } from "./news-info.vue?vue&type=template&id=64dcd3c2&scoped=true&"
import script from "./news-info.vue?vue&type=script&lang=js&"
export * from "./news-info.vue?vue&type=script&lang=js&"
import style0 from "./news-info.vue?vue&type=style&index=0&id=64dcd3c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dcd3c2",
  null
  
)

export default component.exports